export enum FORM_NAME {
  CREATE_BANNER = 'CREATE_BANNER',
  UPDATE_BANNER = 'UPDATE_BANNER',
}
